import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {
  1: { // Exercise num
    unit: 'Unit 2',
    id: 'SB4-U2-P17-E1',
    audio: 'img/FriendsPlus/Page17/Audio/audio-e1-p17.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page17/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/tieude-e1-p17.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page17/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page17/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/ae.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page17/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/face.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/space.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page17/E1/10.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/ie.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/11.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/kite.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/12.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/bike.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/13.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page17/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page17/E1/15.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/oe.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page17/E1/17.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/rope.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/18.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/stone.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page17/E1/20.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/ue.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/21.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/june.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/22.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/cube.mp3' },
        { url: 'img/FriendsPlus/Page17/E1/23.jpg' },
      ],

    ],
  },

  2: { // Exercise num
    unit: 'Unit 2',
    id: 'SB4-U2-P17-E2',
    audio: 'img/FriendsPlus/Page17/Audio/audio-e2-p17.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page17/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/tieude-e2-p17.mp3' },
        { url: 'img/FriendsPlus/Page17/E2/3.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E2/4.jpg' },
      ],
    ],
  },

  3: { // Exercise num
    unit: 'Unit 2',
    id: 'SB4-U2-P17-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 4,
    exerciseKey: 'img/FriendsPlus/Page17/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page17/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page17/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/6.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page17/E3/7.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page17/E3/8.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page17/E3/9.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page17/E3/10.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page17/E3/11.jpg', input: 6, },
        { url: 'img/FriendsPlus/Page17/E3/12.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page17/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/14.jpg', input: 7, },
        { url: 'img/FriendsPlus/Page17/E3/15.jpg', input: 8, },
        { url: 'img/FriendsPlus/Page17/E3/16.jpg', input: 9, },
        { url: 'img/FriendsPlus/Page17/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/18.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page17/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/20.jpg', input: 10, },
        { url: 'img/FriendsPlus/Page17/E3/21.jpg', input: 11, },
        { url: 'img/FriendsPlus/Page17/E3/22.jpg', input: 12, },
        { url: 'img/FriendsPlus/Page17/E3/23.jpg', input: 13, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/24.jpg', input: 14, },
        { url: 'img/FriendsPlus/Page17/E3/25.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page17/E3/26.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page17/E3/27.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/28.jpg', input: 15, },
        { url: 'img/FriendsPlus/Page17/E3/29.jpg', input: 16, },
        { url: 'img/FriendsPlus/Page17/E3/30.jpg', input: 17, },
        { url: 'img/FriendsPlus/Page17/E3/31.jpg', input: 18, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/32.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page17/E3/33.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/34.jpg', input: 19, },
        { url: 'img/FriendsPlus/Page17/E3/35.jpg', input: 20, },
        { url: 'img/FriendsPlus/Page17/E3/36.jpg', input: 21, },
        { url: 'img/FriendsPlus/Page17/E3/37.jpg', input: 22, },
        { url: 'img/FriendsPlus/Page17/E3/38.jpg', input: 23, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/39.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page17/E3/40.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/41.jpg', input: 24, },
        { url: 'img/FriendsPlus/Page17/E3/42.jpg', input: 25, },
        { url: 'img/FriendsPlus/Page17/E3/43.jpg', input: 26, },
        { url: 'img/FriendsPlus/Page17/E3/44.jpg', input: 27, },
        { url: 'img/FriendsPlus/Page17/E3/45.jpg', input: 28, },
        { url: 'img/FriendsPlus/Page17/E3/46.jpg', input: 29, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/47.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page17/E3/48.jpg' },
      ],

    ],
  },

  4: { // Exercise num
    unit: 'Unit 2',
    id: 'SB4-U2-P17-E4',
    audio: 'img/FriendsPlus/Page17/Audio/audio-e4-p17.mp3',
    video: '',
    component: D1,
    padding: 0,
    textAlign: 'center',
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page17/E4/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E4/1.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page17/Audio/tieude-e4-p17.mp3' },
        { url: 'img/FriendsPlus/Page17/E4/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page17/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page17/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/6.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page17/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/8.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page17/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/10.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page17/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/12.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page17/E4/13.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page17/E4/14.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page17/E4/15.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/16.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page17/E4/17.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/18.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page17/E4/19.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/20.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page17/E4/21.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/22.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page17/E4/23.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/24.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page17/E4/25.jpg' },
        { url: 'img/FriendsPlus/Page17/E4/26.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page17/E4/27.jpg' },
      ],


    ]
  },

  5: { // Exercise num
    unit: 'Unit 2',
    id: 'SB4-U2-P17-E5',
    audio: '',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E5/1.jpg' },

      ]
    ],
  },

}

export default json;